<template>
  <div class="game-tr-text-block-with-input-impr">
    <div
      v-for="(image, index) in imageData"
      class="main-image-container"
      :style="getImageStyle(image)"
      :key="'image' + index"
    ></div>
    <div
      class="text-element"
      v-for="(item, index) in staticText"
      :key="'text_' + index"
      :style="getStaticTextStyle(item)"
      v-html="item.text"
    ></div>
    <tr-box
      v-if="words.length"
      :items="words"
      :config="boxConfig"
      :font-size="boxConfigFontSize"
      :style="getBoxStyle(startGameConfig.boxConfig)"
      class="box-style"
    ></tr-box>
    <div class="text-container" :style="getTextStyle(elem)" v-for="(elem, index) in textItem" :key="index">
      <component :is="dynComponent(index)" v-bind="$props"></component>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import Vue from 'vue';
import * as utils from '../../Utils/inputUtilsV2';
import TrInput from '../TrInput/TrInputV2';
import TrBox from '../../GameBaseElements/TrBox/TrBoxV2';
import defaultMixin from '../../mixins/defaultMixinV2';
import inputMixin from '../../mixins/inputMixinV2';
export default {
  name: 'tr-text-block-with-input-impr-v2',
  components: { TrInput, TrBox },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  mixins: [defaultMixin, inputMixin],
  data() {
    return {
      imageData: [],
      textItem: [],
      staticText: [],
      inputData: [],
      baseItems: _.cloneDeep(this.startGameConfig.items),
      words: [],
      boxConfig: {
        x: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.left) || 1,
        y: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.top) || 14,
        width: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.width) || 98,
        height: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.height) || 12,
        unit: '%',
      },
    };
  },
  created() {},
  beforeMount() {
    this.init();
  },
  methods: {
    /**
     * parsing function. Replace markes (__elem0__,__elem1__, etc.) to component and passing all data
     * @method parseText
     * @param  {String}  text base text with markers
     * @return {String}       reparsed text with correct components
     */
    parseText(text, indexElem) {
      // let regExp = /__\w*__/g;
      text = _.split(text, /__\w*__/g);
      // text = regExp.exec(text);
      let pText = [];
      _.each(text, (item, index) => {
        if (index === 0) {
          pText.push(`<div class="text-with-input"
          :style="getStyle(baseItems[${index}])">`);
        }
        if (index <= text.length - 2) {
          let newText = `<tr-input
            :config="baseItems[${index}]"
            :tr-input-value="inputData"
            :tr-input-value-index="${index}"
            :inputWidth="inputWidth(baseItems[${index}])"
            :inputHeight="inputHeight(baseItems[${index}])"
            @click.native="resetCheckStatus"
            class="input-style"
            :max-length="baseItems.inputMaxLength||startGameConfig.inputMaxLength"
          ></tr-input>`;
          // :key="baseItems[${index}].id"
          // :input-font-size="item.inputFontSize||startGameConfig.inputFontSize"
          if (item) {
            pText.push('<div class="text-block-inner-text" :style="getInnerTextStyle(baseItems[0])">');
            pText.push(item);
            pText.push('</div>');
          }
          pText.push(newText);
        } else {
          pText.push(`<div  class="text-block-inner-text" :style="getInnerTextStyle(baseItems[0])">`);
          pText.push(item);
          pText.push('</div>');
        }
      });
      pText.push('</div>');
      return pText.join('');
    },
    init() {
      this.textItem = this.prepareData();
      // if (this.startGameConfig.mainImage) {
      //   this.imageData = this.startGameConfig.mainImage;
      // }
      let markersArray = [];
      _.each(this.textItem, (item) => {
        if (item.markers) {
          _.each(item.markers, (marker) => {
            markersArray.push(marker);
          });
        } else {
          markersArray.push(item);
        }
      });
      // this.textItem = markersArray;
      this.inputData = _.map(markersArray, (item) => {
        return {
          correct: item.correct,
          val: item.value || '',
          block: item.block || false,
          inputStatus: item.inputStatus || null,
          caseSensitive: item.caseSensitive || this.caseSensitive,
        };
      });
      this.textItem = _.map(this.textItem, (item) => {
        item.text = this.parseText(item.text);
        return item;
      });
    },
    processData(node, staticText, imageArray, parentNode) {
      if (node.items) {
        // if(status.lengt>0){}
        if (node.pick && node.shuffle) {
          node.items = _.sampleSize(_.cloneDeep(node.items), node.pick);
        } else if (node.pick) {
          node.items = _.take(_.cloneDeep(node.items), node.pick);
        }
        if (node.shuffle) {
          node.items = _.shuffle(node.items);
        }
        if (node.staticText) {
          staticText.push(node.staticText);
        }
        if (node.imageData) {
          imageArray.push(node.imageData);
        }
        return _.flattenDeep(
          _.map(node.items, (item) => {
            return this.processData(item, staticText, imageArray, node);
          })
        );
      }
      // let status = _.filter(node.items, 'staticIndex');
      if (node.staticText) {
        staticText.push(node.staticText);
      }
      if (node.imageData) {
        imageArray.push(node.imageData);
      }
      return node;
    },
    prepareData() {
      let staticText = [];
      let imageArray = [];
      let pick = this.startGameConfig.pick;
      let data = _.cloneDeep(this.startGameConfig.items);
      let staticIndexArray = _.filter(data, (item) => {
        return !_.isNil(item['staticIndex']);
      });
      if (staticIndexArray.length > 0) {
        pick = this.startGameConfig.pick - staticIndexArray.length;
        data = _.difference(data, staticIndexArray);
      }
      if (this.startGameConfig.items && this.startGameConfig.pick && this.startGameConfig.shuffle) {
        data = _.sampleSize(_.cloneDeep(data), pick);
      } else if (this.startGameConfig.items && pick) {
        data = _.take(_.cloneDeep(data), pick);
      } else if (this.startGameConfig.items && this.startGameConfig.shuffle) {
        data = _.shuffle(data);
      }
      _.each(staticIndexArray, (item) => {
        data.push(item);
      });
      data = _.flattenDeep(
        _.map(data, (item) => {
          return this.processData(item, staticText, imageArray, this.startGameConfig);
        })
      );
      /** add image layout */
      this.imageData = imageArray;
      if (this.startGameConfig.mainImage) {
        this.imageData.unshift(this.startGameConfig.mainImage);
      } else if (this.startGameConfig.background) {
        this.imageData = Object.assign({}, { imagePath: this.startGameConfig.background });
      }
      /** shuffle words in box */
      if (this.startGameConfig.words) {
        this.words = _.shuffle(_.cloneDeep(this.startGameConfig.words));
      }
      /** set staticIndex (fixed position) */
      let sData = {};
      let staticData = _.filter(data, (item) => {
        return !_.isNil(item.staticIndex);
      });
      if (staticData.length > 0) {
        staticData = _.sortBy(_.cloneDeep(staticData), ['staticIndex']);
        data = _.map(data, (item) => {
          if (_.isNil(item.staticIndex)) {
            return item;
          }
        });
      }
      data = _.compact(data);
      sData = _.difference(data, staticData);
      _.each(staticData, (item) => {
        sData.splice(item.staticIndex, 0, item);
      });
      data = sData;
      /** add layout image */
      if (this.startGameConfig.layoutImage && this.startGameConfig.layoutImage.length) {
        let imageList = _.cloneDeep(this.imageData);
        let first;
        if (this.startGameConfig.mainImage) {
          first = _.head(imageList);
          imageList = _.tail(imageList);
        }
        this.imageData = _.map(_.cloneDeep(imageList), (item, index) => {
          return _.defaultsDeep(_.cloneDeep(item), _.cloneDeep(this.startGameConfig.layoutImage[index]));
        });
        if (this.startGameConfig.mainImage) {
          this.imageData.unshift(first);
        }
      }
      /** add static text */
      if (this.startGameConfig.staticText) {
        if (
          this.startGameConfig.staticText[0] &&
          this.startGameConfig.staticText[0].items &&
          this.startGameConfig.staticText[0].items.length > 0
        ) {
          if (this.startGameConfig.staticText[0].pick) {
            staticText = _.map(this.startGameConfig.staticText, (elem) => {
              return _.take(_.cloneDeep(elem.items), elem.pick);
            });
            staticText = _.flatten(staticText);
            // staticText.push(_.sampleSize(_.cloneDeep(staticText[0].items), staticText[0].pick));
          }
        }
        staticText = this.startGameConfig.staticText;
      }
      if (staticText.length > 0) {
        this.staticText = _.map(staticText, (item, index) => {
          if (this.startGameConfig.layoutStaticText) {
            return Object.assign(item, this.startGameConfig.layoutStaticText[index]);
          } else {
            return item;
          }
        });
      }
      this.textItem = _.map(_.cloneDeep(data), (item, index) => {
        return _.defaultsDeep(item, _.cloneDeep(this.startGameConfig.layoutItems[index]));
      });
      /**
       * add words box to game
       */
      if (this.startGameConfig.words) {
        let syncData = this.startGameConfig.boxConfig.syncData;
        this.words = this.startGameConfig.words;
        if (this.startGameConfig.boxConfig && syncData) {
          this.words = _.intersection(
            this.startGameConfig.words,
            _.flattenDeep(
              _.map(this.textItem, (item) => {
                if (item[syncData]) {
                  return [...item[syncData]];
                } else if (item.markers) {
                  return _.flattenDeep(
                    _.map(item.markers, (item) => {
                      return [...item[syncData]];
                    })
                  );
                }
                return [...item[syncData]];
              })
            )
          );
        }
        this.words = _.shuffle(this.words);
      }
      return _.cloneDeep(this.textItem);
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getImage(item) {
      return 'static/' + item.imagePath;
      // return 'assets/config/' + item.imagePath;
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }
      return _.merge(
        {
          'background-size': 'contain',
          'background-repeat': 'no-repeat',
          'background-position': 'center,center',
          position: 'relative',
          display: 'block',
          'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        },
        this.getCustomStyle(imageData),
        {
          top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
          left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
          width: utils.elementWidth(imageData.width),
          height: utils.elementHeight(imageData.height),
        }
      );
    },
    setGameStyle() {
      return {
        'flex-direction': this.startGameConfig.flexDirection || 'row',
      };
    },
    getStaticTextStyle(staticTextElement) {
      staticTextElement.offsetVertical = staticTextElement.offsetVertical
        ? staticTextElement.offsetVertical
        : this.startGameConfig.staticTextElementOffsetVertical;
      staticTextElement.offsetHorizontal = staticTextElement.offsetHorizontal
        ? staticTextElement.offsetHorizontal
        : this.startGameConfig.staticTextElementOffsetHorizontal;
      staticTextElement.width = staticTextElement.width
        ? staticTextElement.width
        : this.startGameConfig.staticTextElementWidth;
      staticTextElement.height = staticTextElement.height
        ? staticTextElement.height
        : this.startGameConfig.staticTextElementHeight;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(staticTextElement), {
        top: utils.elementTopPosition(staticTextElement.pos.y, staticTextElement.offsetVertical),
        left: utils.elementLeftPosition(staticTextElement.pos.x, staticTextElement.offsetHorizontal),
        width: utils.elementWidth(staticTextElement.width),
        height: utils.elementHeight(staticTextElement.height),
      });
    },
    getTextStyle(element) {
      return _.merge({ position: 'absolute' }, this.getCustomStyle(element), {
        top: utils.elementTopPosition(element.pos.y, element.offsetVertical),
        left: utils.elementLeftPosition(element.pos.x, element.offsetHorizontal),
        width: element.blockWidth
          ? utils.elementWidth(element.blockWidth)
          : utils.elementWidth(this.startGameConfig.blockWidth),
        height: element.blockHeight
          ? utils.elementHeight(element.blockHeight)
          : utils.elementHeight(this.startGameConfig.blockHeight),
        'background-color': element.blockBackgroundColor || this.startGameConfig.blockBackgroundColor,
        'font-size': this.startGameConfig.gameFontSize + 'px',
      });
    },
    getBoxStyle(box) {
      box.x = box.x;
      box.y = box.y;
      box.width = box.width;
      box.height = box.height;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(box), {
        left: utils.elementLeftPosition(box.x, 0, '%'),
        top: utils.elementTopPosition(box.y, 0, '%'),
        width: utils.elementWidth(box.width, '%'),
        height: utils.elementHeight(box.height, '%'),
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    /**
     * reset all containerEnd without reset reactivity
     * @method resetGameAction
     */
    resetGameAction() {
      this.init();
    },
    checkGameAction() {
      return this.inputOnBackgroundCheckGameAction();
      // let status = _.reduce(this.inputData, (result, value, key) => {
      //   let temVal = null;
      //   let index = _.findIndex(value.correct, (o) => {
      //     if (value.caseSensitive) {
      //       return o === _.trim(value.val);
      //     } else {
      //       return o === _.trim(value.val.toLowerCase());
      //     }
      //   });
      //   if (index != -1) {
      //     temVal = result && true;
      //     if (value.caseSensitive) {
      //       value.val = _.trim(value.val);
      //     } else {
      //       value.val = _.trim(value.val.toLowerCase());
      //     }
      //     value.block = true;
      //     value.inputStatus = 'correct';
      //   } else {
      //     temVal = false;
      //     value.val = "";
      //     value.block = true;
      //     value.inputStatus = 'incorrect';
      //     setTimeout(() => {
      //       value.val = "";
      //       value.block = false;
      //       value.inputStatus = null;
      //     }, 1000);
      //   }
      //   return temVal;
      // }, true);
      // // console.log('ANSWER: ', status);
      // if (!status) {
      //   _.each(this.inputData, (item, key) => {
      //     // console.log('item', item);
      //   });
      // }
      // return status;
    },
    getCorrectIndex(inputData, textItem, index) {
      let arrayIndex = 0;
      for (var i = 0; i < index; i++) {
        if (textItem[i] && textItem[i].markers) {
          _.each(textItem[i].markers, (item) => {
            arrayIndex++;
          });
        } else {
          arrayIndex++;
        }
      }
      return arrayIndex;
    },
    getCorrectInput(index) {
      let array = [];
      let correctIndex = this.getCorrectIndex(this.inputData, this.textItem, index);
      if (this.textItem[index].markers) {
        _.each(this.textItem[index].markers, (item, index) => {
          array.push(this.inputData[correctIndex + index]);
        });
      } else {
        array.push(this.inputData[correctIndex]);
      }
      return array;
    },
    getCorrectBaseItems(index) {
      let markersArray = [];
      if (this.textItem[index] && this.textItem[index].markers) {
        _.each(this.textItem[index].markers, (marker) => {
          markersArray.push(_.extend(marker, _.omit(this.textItem[index], ['markers', 'pos'])));
        });
      } else {
        markersArray.push(_.omit(this.textItem[index], ['pos']));
      }
      return markersArray;
    },
    dynComponent(index) {
      // let templElem = this.textItem.pop();
      let correctInput = this.getCorrectInput(index);
      // let correctBaseItems = this.getCorrectBaseItems( index );
      let correctIndex = this.getCorrectIndex(this.inputData, this.textItem, index);
      let markersLength = this.textItem[index].markers ? this.textItem[index].markers.length : 1;
      const template = this.content ? this.content : this.textItem[index].text;
      let data = {
        mainImage: _.cloneDeep(this.startGameConfig.mainImage),
        text: _.cloneDeep(this.textItem[index].text),
        // inputData: this.inputData[ index ],
        // inputData:this.inputData,
        inputData: correctInput,
        // baseItems: _.cloneDeep( [ _.omit( this.textItem[ index ], [ "pos" ] ) ] )
        baseItems: _.cloneDeep(this.getCorrectBaseItems(index)),
        // items: _.cloneDeep(this.startGameConfig.items)
      };
      return {
        template,
        mixins: [defaultMixin],
        components: { TrInput },
        data() {
          return data;
        },
        methods: {
          selectConfig(item) {
            return _.omit(item, ['pos', 'width', 'height']);
          },
          getStyle(item) {
            return _.merge({}, this.getCustomStyle(item), {
              width: item.textBlockWidth
                ? utils.elementWidth(item.textBlockWidth)
                : utils.elementWidth(this.startGameConfig.textBlockWidth),
              height: item.textBlockHeight
                ? utils.elementHeight(item.textBlockHeight)
                : utils.elementHeight(this.startGameConfig.textBlockHeight),
              // 'justify-content': ( item.flexJustify ) ? 'center' : item.flexJustify,
            });
          },
          getInnerTextStyle(item) {
            return _.assign({}, this.getCustomInnerTextStyle(item));
          },
          getCustomInnerTextStyle(item) {
            let customStyle = {};
            if (item.cssInnerTextStyle) {
              if (_.isObject(item.cssInnerTextStyle)) {
                customStyle = _.mapKeys(item.cssInnerTextStyle, function (value, key) {
                  return _.toString(key);
                });
              }
            }
            return customStyle;
            // return {
            //   'width': (item.textBlockWidth) ? utils.elementWidth(item.textBlockWidth) : utils.elementWidth(this.startGameConfig.textBlockWidth),
            //   'height': (item.textBlockHeight) ? utils.elementHeight(item.textBlockHeight) : utils.elementHeight(this.startGameConfig.textBlockHeight),
            //   'justify-content': (item.flexJustify) ? 'center' : item.flexJustify,
            // };
          },
          getCustomStyle(item) {
            let customStyle = {};
            if (item.cssStyle) {
              if (_.isObject(item.cssStyle)) {
                customStyle = _.mapKeys(item.cssStyle, function (value, key) {
                  return _.toString(key);
                });
              }
            }
            return customStyle;
            // return {
            //   'width': (item.textBlockWidth) ? utils.elementWidth(item.textBlockWidth) : utils.elementWidth(this.startGameConfig.textBlockWidth),
            //   'height': (item.textBlockHeight) ? utils.elementHeight(item.textBlockHeight) : utils.elementHeight(this.startGameConfig.textBlockHeight),
            //   'justify-content': (item.flexJustify) ? 'center' : item.flexJustify,
            // };
          },
          inputWidth(item) {
            if (item.inputWidth) {
              return item.inputWidth;
            } else if (this.startGameConfig.inputWidth) {
              return this.startGameConfig.inputWidth;
            }
            return false;
          },
          inputHeight(item) {
            if (item.inputHeight) {
              return item.inputHeight;
            } else if (this.startGameConfig.inputHeight) {
              return this.startGameConfig.inputHeight;
            }
            return false;
          },
          setNewValue(value, index) {
            let trValue = _.defaults({}, value, {
              correct: undefined,
              val: '',
              block: false,
              inputStatus: null,
              caseSensitive: false,
            });
            trValue.val = value.text;
            _.assign(this.inputData[index], trValue, { val: value });
          },
        },
        // computed:{
        //   inputData(){
        //     if(this.inputData[ index ].markers)
        //     return this.inputData[ index ],
        //   },
        // }
        props: this.$props,
      };
    },
  },
  computed: {
    boxConfigFontSize() {
      let fontSize = this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.fontSize;
      return fontSize + 'px';
    },
    caseSensitive() {
      return this.startGameConfig.caseSensitive;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
$elementWidth: 1478px;
$elementHeight: 153px;
$fontSize: 35px;
%item {
  transition: all 0.5s;
  text-align: center;
  font-size: $fontSize;
  font-family: $gameFontFamily;
  font-style: normal;
  font-variant: normal;
  font-weight: 500;
}
.game-tr-text-block-with-input-impr {
  height: 100%;
  width: 93%;
  margin-left: 1%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .text-container {
    text-align: justify;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.text-with-input {
  display: flex;
  width: 250px;
  justify-content: space-between;
  align-items: baseline;
  flex-direction: row;
}
.text-block-inner-text {
  white-space: pre;
  // margin-right: 1em;
  // margin-left: 1em;
}
.marker-style {
  width: 100px;
  height: 40px;
  display: inline-block;
}
</style>
<style lang="scss">
.game-tr-text-block-with-input-impr {
  .text-container {
    .text-with-input {
      .text-block-inner-text {
        white-space: pre;
        // margin-right: 1rem;
        // margin-left: 1rem;
      }
    }
  }
}
</style>
